import React, { useEffect } from "react";
import Layout from "@/components/Layout";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import ProjectInfoCard from "@/pages/ProjectDetailsPage/components/ProjectInfoCard.tsx";
import ProjectDocumentationTable from "@/pages/ProjectDetailsPage/components/ProjectDocumentationTable.tsx";
import EnrollmentProcessingCard from "@/pages/ProjectDetailsPage/components/EnrollmentProcessingCard.tsx";
import VirtualPeakerSection from "@/pages/ProjectDetailsPage/components/VirtualPeakerSection.tsx";
import { useNavigate, useParams } from "react-router-dom";
import { useProjectsStore } from "@/store/projectsStore.ts";
import DeleteAccountCard from "@/pages/admin-pages/UserProfilePage/components/DeleteAccountCard.tsx";
import { deleteProjectReq, getProjectReq } from "@/api/projectsApi";
import ProjectsNavigation from "@/pages/ProjectDetailsPage/components/ProjectsNavigation.tsx";
import { useAuthStore } from "@/store/authStore.ts";
import NoteSection from "@/pages/ProjectDetailsPage/components/NoteSection";

const ProjectDetailsPage = () => {
  const theme = useTheme();
  const role = useAuthStore((state) => state.role);

  const projectsIds = useProjectsStore((state) => state.projectsIds);

  const getProjectsIds = useProjectsStore((state) => state.getProjectsIds);
  const getProjectFiles = useProjectsStore((state) => state.getProjectFiles);

  const matchesDownLg = useMediaQuery(theme.breakpoints.down("xl"));
  const { id } = useParams();
  const setProjectDetails = useProjectsStore(
    (state) => state.setProjectsDetails
  );
  const projectDetails = useProjectsStore((state) => state.projectDetails);
  const navigate = useNavigate();

  useEffect(() => {
    const getProjectDetails = async (projectId: string) => {
      try {
        const response = await getProjectReq(Number(projectId));
        setProjectDetails(response?.data?.project);
      } catch (e: any) {
        if (e?.response && e?.response?.status === 404) {
          navigate("/not-found");
        }
        console.error(e);
      }
    };

    if (id) {
      getProjectDetails(id);
    }
  }, [id]);

  const handleDeleteProject = async () => {
    if (id) {
      try {
        await deleteProjectReq(Number(id));
        navigate("/projects");
      } catch (e) {
        console.error(e);
      }
    }
  };
  return (
    <Layout>
      <Box
        sx={{
          marginTop: "28px",
          display: "flex",
          width: "100%",
          flexDirection: "column",
          gap: "24px",
        }}
      >
        {matchesDownLg && (
          <Box sx={{ width: "100%", height: "48px", position: "relative" }}>
            <ProjectsNavigation
              navigateTo={(projectId, searchParams) => {
                navigate(`/projects/${projectId}?${searchParams.toString()}`);
              }}
              ids={projectsIds}
              getIds={getProjectsIds}
            />
          </Box>
        )}
        {id && (
          <ProjectInfoCard
            getFilesReq={() => getProjectFiles(Number(id), 1, 10, "", [], null)}
            projectId={Number(id)}
          />
        )}
        <EnrollmentProcessingCard />
        <ProjectDocumentationTable projectId={Number(id)} />
        {role === "administrator" && projectDetails && (
          <VirtualPeakerSection project={projectDetails} />
        )}
        {role === "administrator" && (
          <DeleteAccountCard
            onDelete={handleDeleteProject}
            buttonText={"Delete Project"}
            confirmationText={"I confirm project deletion"}
            headerText={"Delete Project"}
          />
        )}
        <NoteSection />
      </Box>
    </Layout>
  );
};

export default ProjectDetailsPage;
